import * as actionTypes from '../../actions/actionTypes';

const userActionTypes = actionTypes.userActionTypes;

/*+++++++++++++++++++++++++++
/+ EMAIL PAGE
+++++++++++++++++++++++++++*/

/**
 * Email address reducer: update state client email address
 * @param {string} state - current state
 * @param {object} action
 * @return {string} next state
 */
export function emailAddress(state = null, action) {
	switch (action.type) {
		case userActionTypes.UPDATE_EMAIL_ADDRESS:
			return action.emailAddress;
		default:
			return state;
	}
}


/*+++++++++++++++++++++++++++
 /+ PASSWORD PAGE
 +++++++++++++++++++++++++++*/

/**
 * password reducer: update state client password
 * @param {string} state - current state
 * @param {object} action
 * @return {string} next state
 */
export function password(state = null, action) {
	switch (action.type) {
		case userActionTypes.UPDATE_PASSWORD:
			return action.password;
		default:
			return state;
	}
}

/*+++++++++++++++++++++++++++
 /+ REGISTER PAGE
 +++++++++++++++++++++++++++*/

/**
 * firstName reducer: update state client firstName
 * @param {string} state - current state
 * @param {object} action
 * @return {string} next state
 */
export function firstName(state = null, action) {
	switch (action.type) {
		case userActionTypes.UPDATE_FIRSTNAME:
			return action.firstName;
		default:
			return state;
	}
}

/**
 * lastName reducer: update state client lastName
 * @param {string} state - current state
 * @param {object} action
 * @return {string} next state
 */
export function lastName(state = null, action) {
	switch (action.type) {
		case userActionTypes.UPDATE_LASTNAME:
			return action.lastName;
		default:
			return state;
	}
}

export function fbLoginScope(state = null, action) {
	switch (action.type) {
		case userActionTypes.UPDATE_FB_LOGIN_SCOPE:
			return action.fbLoginScope;
		default:
			return state;
	}
}

export function propsFromHost(state = null, action) {
	switch (action.type) {
		case userActionTypes.SET_PROPS_FROM_HOST:
			return action.propsFromHost;
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/reducers/reducers/userReducers.js